export default __webpack_public_path__ + "static/media/inhumacion.f7b84b46.svg";